import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { deviceMetricsForDeviceQuery } from '../../../../data/deviceMetrics.ts'
import { searchDevicesQuery } from '../../../../data/devices.ts'
import { ServiceDetails } from '../../../../features/serviceManagement/serviceMap/ServiceDetails.tsx'

export const Route = createFileRoute('/_app/smp/serviceMap/device/$deviceId')({
	component: RouteComponent,
	errorComponent: () => <ServiceDetails />,
	loader: async ({ params: { deviceId }, context: { queryClient } }) => {
		queryClient.prefetchQuery(deviceMetricsForDeviceQuery(deviceId))
		await queryClient.ensureQueryData(searchDevicesQuery(deviceId))
	},
})

function RouteComponent() {
	const { deviceId } = Route.useParams()
	const { data } = useQuery({ ...searchDevicesQuery(deviceId), refetchInterval: 1000 * 60 * 10 })
	const device = data?.results.find((d) => d.id === deviceId)
	return <ServiceDetails device={device} />
}
